import {useEffect} from 'react';
import './App.css';
import { Routes, Route} from 'react-router-dom';
import Login from './components/pages/Login';
import Register from "./components/pages/Register";
import ResetPassword from "./components/pages/ResetPassword";
import Admin from './components/pages/Admin';
import styleJSON from "./assets/variables.json";
import CustomerDashboard from './components/pages/Customer/Dashboard';

import DesignSystem from "./assets/DesignSystem.json"
import { createDesignSystem } from "@qastanfit/qastan-ui"

import { setDefaultOptions } from 'date-fns';
import nlBE from 'date-fns/locale/nl-BE';
import PublicInfoFiche from './components/pages/PublicInfoFiche';
import Maintenance from './components/pages/Maintenance';

function App() {

  setDefaultOptions({locale: nlBE})
  createDesignSystem(DesignSystem);

  useEffect(()=>{ 
    let keys = Object.keys(styleJSON);

    keys.forEach(key => {
      if(typeof(styleJSON[key]) === "object"){
        //console.log(styleJSON[key])
        let subkkeys = Object.keys(styleJSON[key]);
        subkkeys.forEach(subkey => {
          document.getElementById('root').style.setProperty(`--${subkey}`, styleJSON[key][subkey])
        });
      }
      else{
      }
    });
  }, [])

  return (
    <>
    
    <Routes>
      <Route path="*" element={<Login language="N"/>}/>

      <Route path="registreren" element={<Register language="N"/>}/>
      <Route path="register" element={<Register language="E"/>}/>
      <Route path="inscriver" element={<Register language="F"/>}/>

      <Route path="paswoord-herstellen" element={<ResetPassword language="N"/>}/>
      <Route path="recover-password" element={<ResetPassword language="E"/>}/>
      <Route path="reinitialiser-mot-de-passe" element={<ResetPassword language="F"/>}/>

      <Route path="portaal/*" element={<CustomerDashboard language="N"/>}/>
      <Route path="portal/*" element={<CustomerDashboard language="E"/>}/>
      <Route path="portail/*" element={<CustomerDashboard language="F"/>}/>

      <Route path="anonymouslink" element={<PublicInfoFiche />}/>

      <Route path="admin/*" element={<Admin/>}/>

      <Route path="maintenance" element={<Maintenance />}/>

    </Routes>
    </>  
  );
}

export default App;
